import { Card, CardContent, IconButton, Tooltip } from "@material-ui/core";
import TableComponent from "components/_refactor/table/table";
import {
  columnTextField,
  columnNumberField,
  columnDateField,
  columnPriceField,
} from "utils/tables-utils";
import { Visibility, LocalShipping } from "@mui/icons-material";

export default function TablePainelEntrega({
  data,
  handleSelectRow,
  currentPage,
  currentSizePerPage,
  totalRegistros,
  onTableChange,
}) {
  const columnModel = [
    columnTextField({
      dataField: "StatusEntrega",
      text: "Status",
      align: "center",
      formatter: (_, row) => {
        const getStatusLabel = () => {
          if (row.StatusEntrega === "ENTREGUE") return "Entregue";
          if (row.StatusEntrega === "EM ATRASO") return "Em Atraso";
          return "Em Andamento";
        };

        return (
          <Tooltip title={getStatusLabel() || row.StatusEntrega || ""}>
            <LocalShipping
              color={
                row.StatusEntrega === "ENTREGUE"
                  ? "success"
                  : row.StatusEntrega === "EM ATRASO"
                  ? "warning"
                  : "primary"
              }
            />
          </Tooltip>
        );
      },
    }),
    columnNumberField({
      dataField: "NumeroPedido",
      text: "Número do Pedido",
      align: "center",
    }),
    columnTextField({
      dataField: "Cnpj",
      text: "CNPJ",
      align: "center",
    }),
    columnTextField({
      dataField: "Loja",
      text: "Loja",
      align: "center",
    }),
    columnTextField({
      dataField: "NotaFiscal",
      text: "Nota Fiscal",
      align: "center",
    }),
    columnDateField({
      dataField: "DataEmissao",
      text: "Data Emissão",
      align: "center",
    }),
    columnPriceField(
      {
        dataField: "ValorNF",
        text: "Valor NF",
        align: "center",
      },
      false
    ),
    columnTextField({
      dataField: "Ocorrencia",
      text: "Ocorrência",
      align: "center",
    }),
    columnDateField({
      dataField: "PreivisaoEntrega",
      text: "Data Previsão Entrega",
      align: "center",
    }),
    columnDateField({
      dataField: "EntregueEm",
      text: "Entregue em",
      align: "center",
    }),
    columnTextField({
      dataField: "view",
      text: "Vizualizar",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Visualizar Detalhes da Entrega">
            <IconButton onClick={() => handleSelectRow(row)} size="small">
              <Visibility size="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <Card>
      <CardContent>
        <TableComponent
          dataTable={data}
          searched={Boolean(data)}
          keyField={"IdDelivery"}
          columnModel={columnModel}
          bootstrapTableProps={{
            remote: true,
            onTableChange: onTableChange,
          }}
          headerTitle="Acompanhamento de Entrega"
          pagination={{
            options: [25, 50, 100],
            totalSize: totalRegistros,
            page: currentPage + 1,
            sizePerPage: currentSizePerPage,
            defaultOption: currentSizePerPage,
            showTotal: true,
          }}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          csvFileName="acompanhamento-entrega"
        />
      </CardContent>
    </Card>
  );
}
